import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classNames from 'classnames/bind';
import { List } from 'immutable';
import styles from './selectOptionListing.scss';

function SelectOption({ className, option, onOptionClick, isSelected }) {
  function getOptionClassNames() {
    return classNames({
      [styles.selectOption]: true,
      [styles.isSelected]: isSelected,
      [className]: !!className,
    });
  }

  function handleOptionClick() {
    onOptionClick(option);
  }

  return (
    <div className={getOptionClassNames()} onClick={handleOptionClick}>
      {option.get('optionLabel')}
    </div>
  );
}

class SelectOptionListing extends React.PureComponent {
  isOptionSelected = (option) => {
    const { selectedOptions } = this.props;
    return !!selectedOptions.find((selectedOption) => {
      return selectedOption.get('id') === option.get('id');
    });
  };

  handleOptionClick = (clickedOption) => {
    const { onOptionClick, selectedOptions, multi } = this.props;
    const clickedOptionIndex = selectedOptions.findIndex((option) => {
      return option.get('id') === clickedOption.get('id');
    });

    if (multi) {
      const updatdSelectedOptions =
        clickedOptionIndex === -1
          ? selectedOptions.push(clickedOption)
          : selectedOptions.remove(clickedOptionIndex);

      onOptionClick(updatdSelectedOptions);
    } else {
      const updatdSelectedOptions =
        clickedOptionIndex === -1 ? List([clickedOption]) : List();

      onOptionClick(updatdSelectedOptions);
    }
  };

  render() {
    const { buttonClassName, selectableOptions } = this.props;
    return selectableOptions
      ? selectableOptions.map((option) => {
          return (
            <SelectOption
              key={option.get('id')}
              buttonClassName={buttonClassName}
              option={option}
              onOptionClick={this.handleOptionClick}
              isSelected={this.isOptionSelected(option)}
            />
          );
        })
      : [];
  }
}

SelectOptionListing.propTypes = {
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  multi: PropTypes.bool,
  onOptionClick: PropTypes.func,
  selectedOptions: ImmutablePropTypes.list,
  selectableOptions: ImmutablePropTypes.listOf(
    ImmutablePropTypes.contains({
      id: PropTypes.string,
      optionLabel: PropTypes.string,
    })
  ).isRequired,
};

export default SelectOptionListing;
